<template>
    <div v-if="showLayout">
        <item-display-layout
            ref="ItemDisplayLayout"
            :setValidatorArr="setValidatorArr"
            :setImportLayoutNames="setImportLayoutNames"
            :setComponentData="setComponentData"
            :itemData="itemData"
            :itemClass="itemClass"></item-display-layout>
        <item-basic-layout class="mt20"
                           ref="ItemBasicLayout"
                           :setValidatorArr="setValidatorArr"
                           :setImportLayoutNames="setImportLayoutNames"
                           :setComponentData="setComponentData"
                           :itemData="itemData"
                           :itemClass="itemClass"
                           :itemKey="itemKey"></item-basic-layout>
        <item-extra-layout class="mt20"
                           ref="ItemExtraLayout"
                           :setValidatorArr="setValidatorArr"
                           :setImportLayoutNames="setImportLayoutNames"
                           :setComponentData="setComponentData"
                           :itemData="itemData"
                           :itemClass="itemClass"></item-extra-layout>
        <item-option-layout class="mt20" v-if="selling === 1"
                            ref="ItemOptionLayout"
                            :setValidatorArr="setValidatorArr"
                            :setImportLayoutNames="setImportLayoutNames"
                            :setComponentData="setComponentData"
                            :itemData="itemData"
                            :itemClass="itemClass"></item-option-layout>
        <item-image-layout class="mt20"
                           ref="ItemImageLayout"
                           :setValidatorArr="setValidatorArr"
                           :setImportLayoutNames="setImportLayoutNames"
                           :setComponentData="setComponentData"
                           :itemData="itemData"
                           :itemClass="itemClass"
        ></item-image-layout>
        <item-detail-image-layout class="mt20" v-if="selling === 1"
                                  ref="ItemImageLayout"
                                  :setValidatorArr="setValidatorArr"
                                  :setImportLayoutNames="setImportLayoutNames"
                                  :setComponentData="setComponentData"
                                  :itemData="itemData"
                                  :itemClass="itemClass"
        ></item-detail-image-layout>
<!--        <item-smart-fitting-layout class="mt20" v-if="fitting === 1"
                                   ref="ItemSmartFittingLayout"
                                   :setValidatorArr="setValidatorArr"
                                   :setImportLayoutNames="setImportLayoutNames"
                                   :setComponentData="setComponentData"
                                   :itemData="itemData"
                                   :itemClass="itemClass"
        ></item-smart-fitting-layout>-->
        <item-memo-layout class="mt20"
                          ref="ItemMemoLayout"
                          :setValidatorArr="setValidatorArr"
                          :setImportLayoutNames="setImportLayoutNames"
                          :setComponentData="setComponentData"
                          :itemData="itemData"
                          :itemClass="itemClass"
        ></item-memo-layout>
        <item-create-save-layout class="mt15"
                                 :writeItem="writeItem"
                                 :itemClass="itemClass"
        ></item-create-save-layout>
    </div>
</template>


<script>
import ItemDisplayLayout from "@/components/item/layout/itemRegister/ItemDisplayLayout";
import ItemBasicLayout from "@/components/item/layout/itemRegister/ItemBasicLayout";
import ItemExtraLayout from "@/components/item/layout/itemRegister/ItemExtraLayout";
import ItemImageLayout from "@/components/item/layout/itemRegister/ItemImageLayout";
import ItemSmartFittingLayout from "@/components/item/layout/itemRegister/ItemSmartFittingLayout";
import ItemMemoLayout from "@/components/item/layout/itemRegister/ItemMemoLayout";
import ItemOptionLayout from "./layout/itemRegister/ItemOptionLayout";
import ItemCreateSaveLayout from "@/components/item/layout/itemRegister/ItemCreateSaveLayout";
import Item from "@/components/item/Item";
import {mapState} from "vuex";
import ItemValidator from "@/components/item/ItemValidator";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";
import ApiFileUpload from "@/mixins/ApiFileUpload";
import {isDev} from "@/api/config";
import ItemDetailImageLayout from "./layout/itemRegister/ItemDetailImageLayout";
import {elasticOption} from "@/api/config";

export default {
    name: "ItemRegisterComponent",
    mixins: [ItemValidator, alertMixins, ApiFileUpload],
    components: {
        ItemDetailImageLayout,
        ItemDisplayLayout,
        ItemBasicLayout,
        ItemExtraLayout,
        ItemImageLayout,
        ItemSmartFittingLayout,
        ItemMemoLayout,
        ItemOptionLayout,
        ItemCreateSaveLayout,
    },
    props: {
        itemKey: {default: '',}
    },
    data() {
        return {
            itemClass: null,
            itemType: 'create',
            itemData: {},
            optionKey: 0,
            isRunning: false,
            showLayout: false,

            validatorArr: [],
            importLayoutNames: [],
            fileInfo: [
                {fileName: 'itemImage', fileType: 'item', required: true, validatorMsg: '대표이미지를 추가해주세요.',},
                {fileName: 'itemOptionImage', fileType: 'itemOption', required: true, validatorMsg: '대표이미지를 추가해주세요.',},
                {fileName: 'detailImage', fileType: 'item_detail', required: false, validatorMsg: '상세이미지를 추가해주세요.',}, //
                {fileName: 'smartFittingImage', fileType: 'item_fitting', required: false, validatorMsg: '스마트 피팅 이미지를 추가해주세요.',}, // 스마트 피팅 이미지 추가
            ],
            deleteFiles: [],
            getKeyName: 'id',
            // brandKey: 0,
            mainItemKey: 0,
            isUpdateFile: false,
        }
    },
    created() {
        this.itemClass = new Item.ItemClass(this.UserInfo)
        if (!util.isEmpty(this.itemKey)) {
            this.getItem(this.itemKey);
        } else {
            this.loadLayout();
        }
    },
    mounted() {
        EventBus.$on('getMainItemKey', res => {
            this.mainItemKey = res
        })
    },
    beforeDestroy() {
        EventBus.$off('getMainItemKey')
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {

        setValidatorArr(arr) {
            this.validatorArr = this.$_.concat(this.validatorArr, arr)
            this.validatorArr = this.$_.uniq(this.validatorArr)
        },
        setImportLayoutNames(name) {
            this.importLayoutNames.push(name);
            this.importLayoutNames = this.$_.uniq(this.importLayoutNames)
        },
        setComponentData(type, value) {
            this[type] = value;
            console.log(type, value);
            if(type === 'itemImage' && util.isEmpty(value.raw)) {
                this.isUpdateFile = true;
            }
        },
        loadLayout() {
            this.showLayout = true;
        },

        getItem(key) {
            let params = {op: 1, fi: 1, ty: 'eot', opf: 1, loc: 1, ip: 0, de: 1, br: 1}
            params[this.getKeyName] = key;
            try {
                this.$api.$item.getItem(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type !== 1 || util.isEmpty(res.List)) {
                        this.createAlert({
                            content: '데이터를 불러올 수 없습니다.',
                            hide: () => {
                                this.$router.back();
                            }
                        })
                        return false;
                    }
                    this.i_idx = res.List[0].i_idx;
                    this.itemData = this.itemClass.getItemData(res.List[0]);
                    this.itemClass.setBeforeBrand(res.List[0].brandInfo);
                    util.Object.each(this.itemData, (key, value, obj) => {
                        this[key] = this.$_.cloneDeep(value);
                    })
                    this.optionKey = res.List[0].io_idx;
                    this.loadLayout();
                    // this.settingItemData(res.List[0])
                })
            } catch (e) {
                console.log(e);
            }
        },
        _checkValidator() {
            return this.$validate(this.validatorArr).then(success => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    util.Array.each(this.importLayoutNames, (layout, index, arr) => {
                        if (this.$refs.hasOwnProperty(layout) && this.$refs[layout].hasOwnProperty('checkValidator')) {
                            this.$refs[layout].checkValidator();
                        }
                    });
                    return success
                }
                if (this.fitting === 1) {
                    this.fileInfo[3].required = true;
                }else {
                    this.fileInfo[3].required = false;
                }
                util.Array.each(this.fileInfo, (fileInfo, index, arr) => {
                    if (success && fileInfo.required && util.isEmpty(this[fileInfo.fileName]) && this.selling === 1) {
                        this.errorAlert(fileInfo.validatorMsg)
                        success = false;
                    } else if (this.selling === 0) {
                        if (index === 0 || index === 1) {
                            if (success && fileInfo.required && util.isEmpty(this[fileInfo.fileName])) {
                                this.errorAlert(fileInfo.validatorMsg)
                                success = false;
                            }
                        }
                    }
                })
                return success;
            })
        },
        _makeOptionParamArr(params) {
            //옵션 사용 여부
            if (this.selling === 1) { //판매중일때
                if (this.optionUse == 0) { //비워주기
                    params.options = this.optionList
                    util.Array.each(params.options, (op, index, arr) => {
                        op.status = 'update';
                    })
                }
                if (this.optionUse == 0 && this.stockUse == 1) { //옵션 사용 x 재고사용 o

                    let stock = String(this.stock).replace(/[^0-9]/g, '');
                    params.ist_stock = Number(stock) //재고
                }
                if (this.optionUse == 1 && util.isEmpty(this.itemKey)) { //옵션 사용 o 등록
                    util.Array.each(this.optionList, (option, index, arr) => {
                        option.io_color = this.color
                        option.io_tone = this.tone
                        option.io_price_org = params.i_price_org
                        option.io_price = params.i_price
                    })
                    params.options = this.optionList
                }
                if (this.optionUse == 1 && !util.isEmpty(this.itemKey)) { //옵션 사용 o 수정
                    util.Array.each(this.optionList, (option, index, arr) => { //수정인데 옵션을 새롭게 등록하는거 체크
                        if (option.hasOwnProperty('status')) {
                            if (option.status !== 'create') {
                                option.status = 'update'
                            }
                        } else {
                            option.status = 'update'
                        }
                        option.io_color = this.color
                        option.io_tone = this.tone
                        option.io_price_org = params.i_price_org
                        option.io_price = params.i_price
                        if (option.ios_use == 0 || util.isEmpty(option.ios_use)) { //옵션내의 재고관리를 사용하지않을 경우
                            delete option.ios_use
                            delete option.ios_stock
                            delete option.ios_idx
                        }
                        //안에 값이 없는 데이터가 있으면 제거합니다.
                        let checkKey = Object.keys(option)
                        let checkNull = checkKey.filter(data => util.isEmpty(option[data]))
                        util.Array.each(checkNull, (checkNull, index, arr) => {
                            delete option[checkNull]
                        })
                    })
                    params.options = this.optionList
                }
            } else { //판매안함일때
                params.options = []
                if (util.isEmpty(this.stockUse)) { //수정시에 재고관리가 null인 데이터가 있어서 넣어뒀습니다.
                    params.ist_use = 0
                }
            }
            return params;
        },
        _makeSendParams() {
            let params = {
                i_display: this.display,
                ic_idx: this.category,
                ie_pattern: this.pattern,
                ie_season: this.season,
                io_color: this.color,
                io_tone: this.tone,
                i_gender: this.gender,
                ie_bottom_type: this.bottomType,
                i_name: this.name,
                ie_link: this.link,
                i_model: this.manageCode,
                //i_price: this.price,
                ie_n_search_word: this.nSearchWord,
                ie_n_rank: this.nRank,
                ie_n_review: this.nReview,
                ie_n_dibs: this.nDibs,
                ie_n_category_num: this.nCategory,
                i_memo: this.memo,

                i_is_option: this.optionUse, //옵션관리
                ist_use: this.stockUse, //재고관리
                i_is_sale: this.discountUse,
                i_is_selling: this.selling,//판매상태
                is_type: 10, //배송관련타입
                i_fitting: this.fitting,//스마트 피팅

                i_brand: this.brandName,
            }
            let price = String(this.price).replace(/[^0-9]/g, '');
            let discount = String(this.discount).replace(/[^0-9]/g, '');
            params.i_price_org = price;
            if (this.discountUse == 1) { //할인 사용 여부
                params.i_price = discount
            } else {
                params.i_price = price;
            }
            params = this._makeOptionParamArr(params);

            if (!util.isEmpty(this.itemKey)) {
                params.i_idx = this.itemKey;
            }
            return params;
        },
        async writeItem() {
            let validator = await this._checkValidator();
            if (!validator) {
                return false;
            }

            if(this.isRunning) {
                return false;
            }
            this.isRunning = true;
            EventBus.$emit('changeLoading', true)
            let data = this._makeSendParams();
            /*EventBus.$emit('changeLoading', false)
            this.isRunning = false;
            return ;*/
            let result = await this.itemClass.runWrite(this.itemType, data);
            if(result.type === true) {
                if(!util.isEmpty(result.optionKey)){
                    this.optionKey = result.optionKey;
                }
                this.removeFiles(this.deleteFiles);
                this.runApiUploadFiles([this.fileInfo[0]], result.key).then(res => {
                    this.setItemImageMasking(result.key);
                    this.runApiUploadFiles([this.fileInfo[1]], this.optionKey).then(res => {
                        this.runApiUploadFiles([this.fileInfo[2]], result.key).then(res => {
                            this.runApiUploadFiles([this.fileInfo[3]], result.key).then(res => { //스마트피팅 이미지 파일까지 돌고
                                this.itemClass.saveBrandInfo(result.key, this.brandKey, this.mainItem).then(res => {
                                    this.elasticIndexing(result.key);
                                })
                            })
                        })
                    })
                })
                /*if(this.itemKey != ''){
                    // if(this.selling !== 0 && this.fitting !== 0){

                }else{
                    this.runApiUploadFiles([this.fileInfo[0]], result.key).then(res => {
                        this.runApiUploadFiles([this.fileInfo[1]], this.optionKey).then(res => {
                            this.runApiUploadFiles([this.fileInfo[2]], result.key).then(res => { //스마트피팅 이미지 파일까지 돌고
                                this.runApiUploadFiles([this.fileInfo[3]], result.key).then(res => { //스마트피팅 이미지 파일까지 돌고
                                    this.itemClass.saveBrandInfo(this.itemKey, this.brandKey, this.brandData.b_idx, this.itemKey, this.mainItem).then(res => {
                                        this.elasticIndexing(result.key);
                                    })
                                })
                            })
                        })
                    })
                }*/
            }else{
                this.errorAlert('저장에 실패하였습니다.')
                this.isRunning = false;
                EventBus.$emit('changeLoading', false)
            }
        },
        setItemImageMasking(key) {
            if(!isDev && this.isUpdateFile) {
                let params = {
                    item_key: key,
                };
                this.$api.$ai.setItemImageMasking(params);
            }

        },
        elasticIndexing(key) {
            let param = {
                i_idx : key,
                index : elasticOption.index
            }
            this.$api.$item.indexingItem(param).then(res => {
                if(res.Data.Result.Info.Type === 1) {
                    this.afterFunc();
                }else{
                    this.isRunning = false;
                    EventBus.$emit('changeLoading', false)
                    this.createAlert({
                        title: "",
                        content: '저장에 실패하였습니다.',
                        btnText: "확인",
                        hide: () => {
                        }
                    });
                }
            })
        },
        afterFunc() {
            setTimeout(() => {
                EventBus.$emit('changeLoading', false);
                this.createAlert({
                    title: "",
                    content: this.itemKey ? '상품이 수정되었습니다.' : '상품이 등록되었습니다.',
                    btnText: "확인",
                    hide: () => {
                        EventBus.$emit('elasticListGetList');
                        //this.$router.push(`/item`)
                        this.$router.back();
                    }
                });
            }, 800)
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>


